module.exports = __webpack_public_path__ + "./fonts/InterTight-MediumItalic.ttf";